import { create } from 'zustand';

/**
 * @deprecated USO RESTRINGIDO - SOLO PARA LOGIN/LOGOUT
 *
 * Este store global SOLO debe usarse en authStore.ts para operaciones de
 * autenticación (login/logout). Para cualquier otra operación usar:
 *
 * - TanStack Query: isPending/isFetching de useMutation/useQuery
 * - Ant Design: confirmLoading en modales, loading en botones
 * - Estado local: useState para casos específicos
 *
 * Razón: El patrón de contador global causaba race conditions y spinners
 * infinitos cuando múltiples operaciones se ejecutaban concurrentemente.
 *
 * Ver CLAUDE.md sección "Loading States" para más detalles.
 */

type State = { requestCount: number; isLoading: boolean };

type Action = {
  startLoading: () => void;
  stopLoading: () => void;
};

const initialState: State = {
  requestCount: 0,
  isLoading: false,
};

export const useLoaderStore = create<State & Action>((set) => ({
  ...initialState,

  startLoading: () =>
    set((state) => ({
      requestCount: state.requestCount + 1,
      isLoading: state.requestCount + 1 > 0,
    })),

  stopLoading: () =>
    set((state) => ({
      requestCount: Math.max(0, state.requestCount - 1),
      isLoading: Math.max(0, state.requestCount - 1) > 0,
    })),
}));
